export enum AnimationPosition {
  TOP = 'Top',
  BOTTOM = 'Bottom',
  LEFT = 'Left',
  RIGHT = 'Right',
}

export enum Size {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum Variant {
  LIGHT = 'light',
  DARK = 'dark',
}
